import axios, {AxiosError, AxiosInstance} from 'axios'
import {showErrorNotification} from 'common/helpers'
import { URL_BASE_RBAC } from '../config'

type Session = {
  token_type: string;
  access_token: string;
}

export const api: AxiosInstance = axios.create({
  baseURL: `${URL_BASE_RBAC}/api`,
})

export const addAuthorizationHeader = (session: Session) => {
  api.defaults.headers.common.Authorization = `${session.token_type} ${session.access_token}`
}

export const handleError = (error: AxiosError<any>) => {
  let message = error.message
  if (error.response) {
    message = error.response.data?.errors
      ? Object.values(error.response.data.errors).flat().join('\n')
      : error.response.data?.message || error.message
  }
  showErrorNotification(message)
  return Promise.reject(error)
}

function logout() {

}

api.interceptors.response.use(undefined, (error) => {
  if (
    error.response?.request?.responseURL.endsWith('logout') ||
    error?.message === 'canceled'
  )
    return
  if (error.response?.status === 401) {
    logout()
    return
  }
  return handleError(error)
})
